module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_6000_Active@1x-3f89cd8c8d91007da0e2df75236e73f8.png";